"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableLevelSearchOption = exports.SortDirection = exports.ColumnLevelSearchOption = void 0;
// Options Prop
var ColumnLevelSearchOption;
exports.ColumnLevelSearchOption = ColumnLevelSearchOption;
(function (ColumnLevelSearchOption) {
  ColumnLevelSearchOption["COLUMN"] = "column";
  ColumnLevelSearchOption["RANGE"] = "range";
  ColumnLevelSearchOption["SELECT"] = "select";
  ColumnLevelSearchOption["DATE"] = "date";
  ColumnLevelSearchOption["NONE"] = "none";
})(ColumnLevelSearchOption || (exports.ColumnLevelSearchOption = ColumnLevelSearchOption = {}));
var TableLevelSearchOption;
exports.TableLevelSearchOption = TableLevelSearchOption;
(function (TableLevelSearchOption) {
  TableLevelSearchOption["COLUMN"] = "column";
  TableLevelSearchOption["ALL"] = "all";
  TableLevelSearchOption["NONE"] = "none";
})(TableLevelSearchOption || (exports.TableLevelSearchOption = TableLevelSearchOption = {}));
var SortDirection;
exports.SortDirection = SortDirection;
(function (SortDirection) {
  SortDirection["ASC"] = "asc";
  SortDirection["DESC"] = "desc";
})(SortDirection || (exports.SortDirection = SortDirection = {}));